"use strict";

var _classCallCheck = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebugInfoTracker = void 0;

var path = require("path");

var FastBitSet = require('fastbitset');

var DebugInfoTracker = /*#__PURE__*/function () {
  function DebugInfoTracker() {
    _classCallCheck(this, DebugInfoTracker);

    this.sourceFileSet = new Set();
    this.sourceFiles = [];
    this.lineStack = [];
    this.pcToLocs = {};
    this.insnBitset = new FastBitSet();
    this.breakpoints = [];
  }

  _createClass(DebugInfoTracker, [{
    key: "startLine",
    value: function startLine(loc, codePC, segment) {
      var source = path.resolve(loc.source);
      var l = {
        source: source,
        lineNo: loc.start.line,
        segmentId: segment.id,
        numBytes: 0
      };
      this.lineStack.push({
        loc: l,
        pc: codePC,
        segmentId: segment.id
      });

      if (!this.sourceFileSet.has(source)) {
        this.sourceFiles.push(source);
        this.sourceFileSet.add(source);
      }
    }
  }, {
    key: "endLine",
    value: function endLine(curPC, curSegment) {
      var entry = this.lineStack.pop();

      if (!entry) {
        throw new Error('internal compiler error, mismatching start/end lines in debugInfo');
      }

      var numBytesEmitted = curPC - entry.pc;

      if (numBytesEmitted > 0 && curSegment.id === entry.segmentId) {
        var e = Object.assign(Object.assign({}, entry.loc), {
          numBytes: numBytesEmitted
        });

        if (this.pcToLocs[entry.pc] === undefined) {
          this.pcToLocs[entry.pc] = [e];
        } else {
          this.pcToLocs[entry.pc].push(e);
        }
      }
    }
  }, {
    key: "markAsInstruction",
    value: function markAsInstruction(start, end) {
      for (var i = start; i < end; i++) {
        this.insnBitset.add(i);
      }
    }
  }, {
    key: "markBreak",
    value: function markBreak(addr, segmentName) {
      this.breakpoints.push({
        addr: addr,
        segmentName: segmentName
      });
    }
  }, {
    key: "info",
    value: function info() {
      var insnBitset = this.insnBitset.clone();

      var isInstruction = function isInstruction(addr) {
        return insnBitset.has(addr);
      };

      return {
        pcToLocs: this.pcToLocs,
        breakpoints: this.breakpoints,
        sourceFiles: this.sourceFiles,
        isInstruction: isInstruction
      };
    }
  }]);

  return DebugInfoTracker;
}();

exports.DebugInfoTracker = DebugInfoTracker;